<ul
  ngbNav
  #nav="ngbNav"
  [id]="options().id"
  [(activeId)]="active"
  (navChange)="onNavChange($event)"
  [destroyOnHide]="false"
  class="nav-tabs"
>
  @if (options().entries) {
    @for (entry of options().entries; track entry.label; let i = $index) {
      @if (
        entry.entries !== null &&
        entry.entries !== undefined &&
        entry.entries.constructor.name === 'Array' &&
        entry.entries.length > 0
      ) {
        <li
          ngbDropdown
          class="nav-item"
          role="presentation"
        >
          <button
            #ddButton
            type="button"
            class="nav-link"
            ngbDropdownToggle
          >
            {{ translations[entry.label] + (this.ddActiveTitle ? ' - ' + this.ddActiveTitle : '') }}
          </button>
          <ul ngbDropdownMenu>
            @for (opts of entry.entries; track opts.label; let j = $index) {
              <button
                ngbDropdownItem
                (click)="changeTab(opts, i + '-' + j)"
              >
                {{ translations[opts.label] }}
              </button>
            }
          </ul>
        </li>
        @for (opts of entry.entries; track opts.label; let j = $index) {
          <li
            [ngbNavItem]="i + '-' + j"
            [destroyOnHide]="opts.destroyOnHide"
            [disabled]="opts.disabled!"
            hidden
          >
            <ng-template
              ngbNavContent
              let-active
            >
              <ng-container
                [ngComponentOutlet]="opts.entry || null"
                [ngComponentOutletInputs]="opts.options ? { options: opts.options() } : {}"
                #outlet="ngComponentOutlet"
              />
            </ng-template>
          </li>
        }
      } @else {
        <li
          [ngbNavItem]="'' + i"
          [destroyOnHide]="entry.destroyOnHide"
          [disabled]="entry.disabled!"
        >
          <button
            ngbNavLink
            (click)="changeTab(entry, '' + i)"
          >
            {{ translations[entry.label] }}
          </button>
          <ng-template
            ngbNavContent
            let-active
          >
            <ng-container
              [ngComponentOutlet]="entry.entry || null"
              [ngComponentOutletInputs]="entry.options ? { options: entry.options() } : {}"
              #outlet="ngComponentOutlet"
            />
          </ng-template>
        </li>
      }
    }
  }
</ul>

<div
  [ngbNavOutlet]="nav"
  class="mt-2"
></div>
